const PRODUCTION_BASE_URL = 'https://dev-agent.savictech.com/autopo/api/v1';

function resolveBaseUrl() {
  const envUrl = (process.env.REACT_APP_PROCURE_API_URL || '').trim();
  if (envUrl) {
    return envUrl.replace(/\/$/, '');
  }

  return PRODUCTION_BASE_URL;
}

const BASE_URL = resolveBaseUrl();

async function apiFetch(path, options = {}) {
  try {
    return await fetch(`${BASE_URL}${path}`, options);
  } catch (err) {
    const message =
      `Cannot connect to ProcureAI backend at ${BASE_URL}. ` +
      'Set REACT_APP_PROCURE_API_URL to your API server (for example, http://<server>:8000/api/v1).';
    throw new Error(message);
  }
}

async function handleResponse(res) {
  if (!res.ok) {
    let detail = `HTTP ${res.status}`;
    try {
      const data = await res.json();
      if (Array.isArray(data.detail)) {
        detail = data.detail
          .map((e) => `[${Array.isArray(e.loc) ? e.loc.join(' -> ') : e.loc}] ${e.msg}`)
          .join(' | ');
      } else if (typeof data.detail === 'string') {
        detail = data.detail;
      } else {
        detail = JSON.stringify(data);
      }
    } catch (_) {}
    throw new Error(detail);
  }

  if (res.status === 204) {
    return null;
  }

  return res.json();
}

function buildQs(params = {}) {
  const clean = Object.fromEntries(
    Object.entries(params).filter(([, value]) => value !== '' && value !== undefined && value !== null)
  );
  const qs = new URLSearchParams(clean).toString();
  return qs ? `?${qs}` : '';
}

export const syncPurchaseRequisitions = () =>
  apiFetch('/procurement/purchase-requisitions/sync', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
  }).then(handleResponse);

export const listPurchaseRequisitions = (params = {}) =>
  apiFetch(
    `/procurement/purchase-requisitions${buildQs({
      status: params.status,
      limit: params.limit ?? 50,
      offset: params.offset ?? 0,
    })}`
  ).then(handleResponse);

export const getPurchaseRequisition = (prNumber) =>
  apiFetch(`/procurement/purchase-requisitions/${encodeURIComponent(prNumber)}`).then(handleResponse);

export const convertPurchaseRequisitionToPo = (prNumber) =>
  apiFetch(`/procurement/purchase-requisitions/${encodeURIComponent(prNumber)}/convert-to-po`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
  }).then(handleResponse);

export const listPurchaseOrders = (params = {}) =>
  apiFetch(
    `/procurement/purchase-orders${buildQs({
      status: params.status,
      limit: params.limit ?? 50,
      offset: params.offset ?? 0,
    })}`
  ).then(handleResponse);

export const getPurchaseOrder = (poNumber) =>
  apiFetch(`/procurement/purchase-orders/${encodeURIComponent(poNumber)}`).then(handleResponse);

export const batchProcessApprovedPrs = () =>
  apiFetch('/procurement/batch-process', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
  }).then(handleResponse);

export const getPoSummaryReport = () =>
  apiFetch('/procurement/reports/po-summary').then(handleResponse);

export const listVendors = () =>
  apiFetch('/procurement/vendors').then(handleResponse);

export const createVendor = (payload) =>
  apiFetch('/procurement/vendors', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  }).then(handleResponse);

export const updateVendor = (vendorId, payload) =>
  apiFetch(`/procurement/vendors/${encodeURIComponent(vendorId)}`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  }).then(handleResponse);

export const listVendorContracts = (vendorId) =>
  apiFetch(`/procurement/vendors/${encodeURIComponent(vendorId)}/contracts`).then(handleResponse);

export const createVendorContract = (vendorId, payload) =>
  apiFetch(`/procurement/vendors/${encodeURIComponent(vendorId)}/contracts`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  }).then(handleResponse);

export const getVendorPerformance = (vendorId) =>
  apiFetch(`/procurement/vendors/${encodeURIComponent(vendorId)}/performance`).then(handleResponse);

export { BASE_URL as PROCURE_API_BASE_URL };
